import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Button, Container, FormHelperText, Grid, Typography } from "@mui/material";
import RtlProvider from '../../../Components/RtlProvider';
import { ContextNotification, severitys } from '../../../App';
import colorApi from '../../../api/colorApi';
import helper from '../../../helper';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import planApi from '../../../api/planApi';
import hotelApi from '../../../api/hotelApi';
import cityApi from '../../../api/cityApi';
import BedCountCircles from '../../../Components/BedCountCircles';
import hotelStructureApi from '../../../api/hotelStructureApi';
import staticVariablesApi from '../../../api/staticVariablesApi';
import Loading from '../../../Components/Loading';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import enumMapper from '../../../enumMapper';


const AddPlan = () => {
  const { open, setOpen } = useContext(ContextNotification);
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  const [hotelStructureIds, setHotelStructureIds] = useState([])
  const [PlanCodeKeys, setPlanCodeKeys] = useState([])
  const [HotelStructure, SetHotelStructure] = useState(null);
  const [Color, SetColor] = useState(null)
  const [submitLoading, setSubmitLoading] = useState(false);

  const schema = yup.object().shape({
    CityConsistency: yup.string().required("شهر را انتخاب نمایید"),
    hotelId: yup.string().required("هتل را انتخاب نمایید"),
    hotelStructureId: yup.string().required("ساختار را انتخاب نمایید"),
    planCode: yup.string().required("کد پلان را انتخاب نمایید"),
    planRoomId: yup.string().required("اتاق ها را انتخاب نمایید")
  });
  const { register, setValue, handleSubmit, formState: { errors }, control, watch, resetField, getValues, reset } = useForm({
    defaultValues: {
      CityConsistency: '',
      hotelId: '',
      planCode: '',
      planRoomId: ''
    },
    mode: "onChange",
    resolver: yupResolver(schema),
  });
  const hotelStructureId = watch("hotelStructureId")

  const onSubmit = (data) => {
    const newData = {
      'planCode': parseInt(data.planCode),
      'hotelStructureId': data.hotelStructureId,
      'planRoomId': data.planRoomId.split(','),
    }
    setSubmitLoading(true);
    planApi.Add(newData).then(async (res) => {
      if (res.data.success) {
        resetField("planRoomId");
        const hotelStructure = await fetchHotelStructureById(hotelStructureId);
        SetHotelStructure(hotelStructure)
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false); });

  };
  useEffect(() => {
    GetCityDropDown();
    GetAllPlanCodeKeys();
  }, []);
  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    setHotels(null);
    resetField("planCode");
    resetField("planRoomId");


    setHotelStructureIds([]);
    resetField("hotelStructureId")
    SetHotelStructure(null)




    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const handleHotelChanged = useCallback(async (id) => {
    resetField("planCode");
    resetField("planRoomId");

    setHotelStructureIds([]);

    resetField("hotelStructureId")
    SetHotelStructure(null)

    if (id) {
      const hotelStructureIds = await fetchHotelStrutureDropDown(id);
      const arr = helper.DictionayToList(hotelStructureIds);
      const mappedReponse = arr.map((r) => {
        return {
          id: r.key,
          label: r.value
        };
      });
      setHotelStructureIds(mappedReponse);


      if (arr.length === 1) {
        setValue("hotelStructureId", arr[0].key);

        SetHotelStructure(null);
        const hotelStructure = await fetchHotelStructureById(arr[0].key);
        SetHotelStructure(hotelStructure);

      }
    }

  }, []);
  const fetchHotelStructureById = async (id) => {
    try {
      let res = await hotelStructureApi.GetHotelStructure(id);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const handleHotelStructureIdChanged = async (id) => {

    // resetField("");
    SetHotelStructure(null);
    if (id) {

      const hotelStructure = await fetchHotelStructureById(id);
      SetHotelStructure(hotelStructure);
    }
  };
  const fetchHotelStrutureDropDown = async (hotelId) => {
    try {
      let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };

  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };
  const fetchHotelStructureByHotelId = async (hotelId) => {
    try {
      let res = await hotelApi.GetHotelStructure(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };

  const GetColor = (planCodeKey) => {
    colorApi.GetByPlanCodeForUser(planCodeKey).then((res) => {
      SetColor(res.data.data);
    }).catch((err) => {
      console.log(errors)
    })
  }

  const GetAllPlanCodeKeys = () => {
    colorApi.Filter(1)
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        setPlanCodeKeys(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))

      })
      .catch((n) => console.log(n));
  };

  const handlePlanCodeKeyChanged = useCallback(async (id) => {
    resetField("planRoomId")
    if (id) {
      GetColor(id)
    }
  });
  return (
    <Container component="main" maxWidth={false}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" {...register("planRoomId")} />
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>
            افزودن پلان
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={!Cities?.length}
                control={control}
                options={Cities ?? []}
                name="CityConsistency"
                placeholder="شهر"
                onChange={handleCityChanged}
                disabled={!Cities?.length}
                error={!!errors?.CityConsistency}
                helperText={errors?.CityConsistency?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={watch("CityConsistency") && !Hotels?.length}
                control={control}
                options={Hotels ?? []}
                name="hotelId"
                placeholder="هتل"
                onChange={handleHotelChanged}
                disabled={!Hotels?.length}
                error={!!errors?.hotelId}
                helperText={errors?.hotelId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={watch("hotelId") && !hotelStructureIds?.length}
                control={control}
                options={hotelStructureIds ?? []}
                name="hotelStructureId"
                placeholder="ساختار"
                onChange={handleHotelStructureIdChanged}
                disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
                style={{
                  border: "none",
                  padding: 0,
                }}
                error={!!errors?.hotelStructureId}
                helperText={errors?.hotelStructureId?.message}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                control={control}
                options={PlanCodeKeys ?? []}
                name="planCode"
                placeholder="کد پلان"
                onChange={handlePlanCodeKeyChanged}
                style={{
                  border: "none",
                  padding: 0,
                }}
                error={!!errors?.planCode}
                helperText={errors?.planCode?.message}
              />
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: 1,
                  bgcolor: Color?.colorCode
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              {/* <Button type="submit" variant="contained" color="secondary">ایجاد پلان</Button> */}
              <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />ایجاد پلان</Button>
              <FormHelperText error={!!errors?.planRoomId}>{errors.planRoomId?.message}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
              {
                //hotelStructureId !== undefined && hotelStructureId !== "" && hotelStructureId !== null && (HotelStructure?.hotelFloorDto?.length === 0 ?
                watch("hotelStructureId") ?
                  !HotelStructure ? <Loading /> :
                    HotelStructure?.hotelFloorDto?.length === 0 ? <p className="error"> طبقات این هتل تعریف نشده است، ابتدا طبقات و اتاق های این هتل را تعریف نمایید</p> : (

                      <div style={{ overflowX: 'auto' }}>
                        <table border={1} cellSpacing={0}>
                          <thead style={{ backgroundColor: '#0070c0', color: '#ffffff' }}>
                            <tr>
                              <th>طبقه</th>
                              <th colSpan={HotelStructure?.hotelFloorDto[0]?.floorsRoomDto?.length}>اتاق</th>
                            </tr>
                          </thead>
                          <tbody style={{ textAlign: 'center' }}>
                            {
                              HotelStructure?.hotelFloorDto?.map((row, index) => (
                                <tr key={row.index}>
                                  <th key={row.floorId}>{row.number}</th>
                                  {
                                    row.floorsRoomDto.map((roomdto, i) => (
                                      <td key={roomdto?.roomId} className={helper.RoomTypeBorderColor(roomdto)} style={{ background: roomdto?.roomPlanInfo != null ? roomdto?.roomPlanInfo?.colorCode : "" }}
                                        onClick={(e) => {
                                          if (roomdto?.roomPlanInfo === null && Color !== null) {
                                            const planRoomId = getValues("planRoomId");
                                            if (!e.currentTarget.style.background) {
                                              if (planRoomId !== "" &&
                                                planRoomId !== null &&
                                                planRoomId !== undefined) {
                                                setValue("planRoomId", planRoomId.concat(",", roomdto?.roomId))
                                                e.currentTarget.style.background = Color?.colorCode;
                                              }
                                              else {
                                                e.currentTarget.style.background = Color?.colorCode;
                                                setValue("planRoomId", roomdto?.roomId)
                                              }
                                            }
                                            else {
                                              e.currentTarget.style.removeProperty("background");
                                              const array = getValues("planRoomId").split(',')
                                              const filteredItems = array.filter(item => item !== roomdto?.roomId);
                                              setValue("planRoomId", filteredItems.join(","))
                                            }

                                          }
                                        }}>
                                        {<div dir='ltr'>{roomdto?.roomNumberWithCode}</div>}
                                        <div style={{ width: '60px' }}>
                                          <BedCountCircles roomdto={roomdto} />
                                        </div>
                                      </td>
                                    ))
                                  }
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    ) : ""
              }
            </Grid>
          </Grid>
        </RtlProvider>
      </form>
    </Container>
  )
}
export default AddPlan;